import { Component, OnInit } from '@angular/core';
import { StorageService } from 'src/app/services/storage.service';
import _ from 'lodash';
import { MatDialog } from '@angular/material/dialog';
import { AlertDialogComponent } from '../dialogs/alert-dialog/alert-dialog.component';
import { StorageAdapter } from '../../adapter/storage-adapter';
@Component({
  selector: 'app-header-menu',
  templateUrl: './header-menu.component.html',
})
export class HeaderMenuComponent implements OnInit {

  constructor(
    private storageService: StorageService,
    private storageAdapter: StorageAdapter,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
  }

  openModal(type) {
    switch (type) {
      case 'startNewProject':
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          width: '480px',
          panelClass: 'selena-calculator',
          data: {
            type: 'NEW_PROJECT'
          },
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result === 'OK') {
            this.storageService.clearStorage();
          }
        });
        break;
    }
  }

  /**
   * Krok 1
   * Otwieranie dialog boxa
   */
  manualOpen() {
    document.getElementById('uploadFile').click();
  }

  /**
   * Krok 2
   * Wczytywanie projektów z dialog boxa
   */
  async addFile(event: any) {
    const file = (document.getElementById('uploadFile') as HTMLInputElement).files[0];

    if (file) {
      const reader: FileReader = new FileReader();
      reader.readAsText(file, 'UTF-8');

      let fileObject = this.storageService.storage;
      const storageService = this.storageService;

      reader.onload = (evt: any) => { // @todo await
        fileObject = JSON.parse(
          // czytanie (w tym polskich znaków)
          // https://stackoverflow.com/questions/30106476/using-javascripts-atob-to-decode-base64-doesnt-properly-decode-utf-8-strings#30106551
          decodeURIComponent(
            atob(evt.target.result.toString()).split('').map((c) => {
              return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join('')
          )
        );

        storageService.storage = this.storageAdapter.adapt(fileObject);

        localStorage.setItem('heatrock_api_results', '');
      };
      return true;
    }

    console.warn('File loading Error');
  }

  /**
   * Zapis projektu do pliku
   */
  manualSave() {
    const a = document.createElement('a');
    a.href = URL.createObjectURL(
      new Blob(
        // zapis (w tym polskich znaków)
        // https://stackoverflow.com/questions/23223718/failed-to-execute-btoa-on-window-the-string-to-be-encoded-contains-characte#26603875
        [btoa(unescape(encodeURIComponent(
          JSON.stringify(this.storageService.storage)
        )))],
        {
          type: 'text/plain'
        }
      )
    );
    a.setAttribute('download',
      (
        this.storageService.storage.projectName
        ? _.snakeCase(this.storageService.storage.projectName)
        : 'selena_calculator'
      ) + '.sln');
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

}
